export default "__VITE_ASSET__CoIzy4dk__"